"use client";
import { ProgressProps } from "@mantine/core";
import Progress from "../Progress";
import classes from "./index.module.css";
import { useCountStepsProgress } from "@/router/useCountStepsProgress";

interface ProgressBarProps {
  progressProps?: ProgressProps;
}

export const ProgressBar = ({ progressProps }: ProgressBarProps) => {
  const progressValue = useCountStepsProgress();
  return (
    <div className={classes.progressFloater}>
      <div className={classes.progressContainer}>
        <Progress {...progressProps} value={progressProps?.value ?? progressValue ?? 0} />
      </div>
    </div>
  );
};
